module.exports = __webpack_public_path__ + "img/no_activity_yet.30570b6a.png";